import React from 'react'
import styled from 'styled-components'

import { onNavigateExternalEvent } from 'analytics/performance'
import {
  BaseMenuButtonProps,
  BaseMenuItem,
  BaseMenuButtonStyle,
  BaseMenuButtonStyleProps,
} from './base-menu-button'
import { useMenuContext } from 'components/styled/menu/menu-context'
import { MenuButtonContent } from 'components/styled/menu/menu-item/menu-button-content'

export interface ExternalMenuLinkProps extends BaseMenuButtonProps {
  href: string
  target?: '_blank' | '_self' | '_parent' | '_top'
}

const StyledMenuExternalLink = styled.a<BaseMenuButtonStyleProps>`
  ${BaseMenuButtonStyle};

  &:hover,
  &:active,
  &:focus,
  &:visited {
    outline: none;
  }
`

export const ExternalMenuLink = ({
  variant = 'basic',
  icon,
  svgIcon,
  text,
  closeMenuOnClick = true,
  textVariant = 'body',
  useOutlinedIcon = false,
  event,
  href,
  target,
  ...props
}: ExternalMenuLinkProps) => {
  const { onClose } = useMenuContext()

  const onButtonClick = () => {
    if (event) onNavigateExternalEvent(event)

    if (closeMenuOnClick) {
      onClose?.()
    }
  }

  return (
    <BaseMenuItem {...props}>
      <StyledMenuExternalLink
        $variant={variant}
        onClick={onButtonClick}
        title={typeof text === 'string' ? text : undefined}
        /* External link props */
        $isSelected={false}
        tabIndex={0}
        href={href}
        target={target}
      >
        <MenuButtonContent
          text={text}
          textVariant={textVariant}
          isSubMenu={false}
          useOutlinedIcon={useOutlinedIcon}
          icon={icon}
          svgIcon={svgIcon}
        />
      </StyledMenuExternalLink>
    </BaseMenuItem>
  )
}
